import PpcBAStateCell from "@/components/PpcBAStateCell.vue";
import PpcInconsistentStatePopover from "@/components/PpcInconsistentStatePopover.vue";
import WrapWithCopy from "@/components/WrapWithCopy.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import TasksMixin from "@/mixins/TasksMixin.vue";
import HoverableImage from "@/components/HoverableImage.vue";
import { ImageElement } from "@/components/tableElements";
import { amz_sp_api_marketplace_ids_country_domains, country_code_amz_sp_api_marketplace_ids } from "@/utils/countries";
import { truncateString } from "@/utils";
export default {
  name: "PpcSPProductAdItem",
  mixins: [TasksMixin],
  components: {
    PpcBAStateCell,
    PpcInconsistentStatePopover,
    WrapWithCopy,
    HoverableImage,
    ImageElement
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    selected_profile_id: {
      type: String
    },
    country_code: {
      type: String
    }
  },
  mounted() {
    this.productAdEditTaskIdentifier = `${this.current_workspace.workspace_id}_${this.item.product_ad_group_id}_ppc_edit_sp_product_ad`;
    this.checkIfAnyPreviousUpdateTaskIsRunning();
  },
  data() {
    return {
      loading: false,
      productAdEditTaskIdentifier: ""
    };
  },
  computed: {
    ...mapState({
      current_workspace: state => state.workspace.current_workspace
    }),
    productAdState() {
      const stateMap = {
        "ENABLED": true,
        "PAUSED": false,
        "MIXED": 'inconsistent'
      };
      return stateMap[this.item.aggregated_state];
    }
  },
  methods: {
    ...mapActions(["ppcEditProductAd"]),
    ...mapMutations(["ppcProductAdUpdateSet"]),
    truncateString,
    async onStateChange(value) {
      this.loading = true;
      const payload = {
        workspace_id: this.current_workspace.workspace_id,
        product_ad_group_id: this.item.product_ad_group_id,
        product_ads_list: this.item.product_ads_details.map(product_ad => {
          return {
            product_ad: {
              ...product_ad
            },
            profile_id: this.selected_profile_id,
            country_code: this.country_code,
            update_dict: {
              state: value
            }
          };
        }),
        task_type: "ppc_edit_sp_product_ad"
      };
      const data = await this.ppcEditProductAd(payload);
      if (data) {
        if (data.task_id === `${this.current_workspace.workspace_id}_${this.item.product_ad_group_id}_ppc_edit_sp_product_ad`) {
          this.productAdEditTaskIdentifier = `${this.current_workspace.workspace_id}_${this.item.product_ad_group_id}_ppc_edit_sp_product_ad`;
          this.executeTaskStatusHandler(data);
          this.checkTaskStatusPeriodically(this.productAdEditTaskIdentifier);
        }
      }
    },
    navigateToLink() {
      const domain = amz_sp_api_marketplace_ids_country_domains[country_code_amz_sp_api_marketplace_ids[this.country_code]];
      const link = "https://www." + domain + "/dp/" + this.item.asin;
      return link;
    },
    checkIfAnyPreviousUpdateTaskIsRunning() {
      this.getAsyncUpdate(this.productAdEditTaskIdentifier);
      this.checkTaskStatusPeriodically(this.productAdEditTaskIdentifier, 2000);
    },
    handleIdle() {
      this.loading = false;
    },
    handleRunning() {
      this.loading = true;
      this.checkTaskStatusPeriodically(this.productAdEditTaskIdentifier, 2000);
    },
    handleFailed(data) {
      this.loading = false;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showDanger", {
        visible: true,
        message: "Product Ad Task failed \n" + data.task_result,
        delay: 60 // Show alert less than 60 secs
      });
    },
    handleFinished(data) {
      this.ppcProductAdUpdateSet(data.task_result);
      this.loading = false;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: "Product Ad Edit Task has finished with success",
        delay: 60 // Show alert less than 60 secs
      });
    }
  }
};